/* @flow */

import { set } from "lodash";

export const unflattenKeys = (collection: {}): {} =>
  Object.entries(collection).reduce(
    (accumulator, [key, value]) => set(accumulator, key, value),
    {}
  );
